import { useRestaurantContext } from '@app/pages/Restaurant/context';
import { RestaurantCustomConfig } from '@app/types';
import { PIXKeyTypes, KEY_PIX_MASKS } from '@app/utils/payments';
import { Button, Typography } from '@material-ui/core';
import { FileCopy } from '@material-ui/icons';
import React, { LegacyRef, useMemo, useState } from 'react';
import classes from './styles.module.css';
import QRCode from 'qrcode.react';

type Props = {
  restaurantConfigurations: RestaurantCustomConfig | null;
};

export default function PIXClipboard({ restaurantConfigurations }: Props) {
  const { primaryColor } = useRestaurantContext();

  const [hasCopied, setHasCopied] = useState(false);

  const keyPIX = restaurantConfigurations?.chavePIX as string;
  const isKeyPixOfTypeQrCode = restaurantConfigurations?.tipoDaChavePIX === PIXKeyTypes.QrCode;

  const maskedKeyPIX = useMemo(() => {
    const keyPIXType = restaurantConfigurations?.tipoDaChavePIX as string;

    const mask = KEY_PIX_MASKS[keyPIXType];
    return mask ? mask.resolve(keyPIX) : keyPIX;
  }, [keyPIX]);

  function handleCopyKeyPIXClick() {
    navigator.clipboard.writeText(keyPIX);
    setHasCopied(true);
    setTimeout(() => {
      setHasCopied(false);
    }, 1000);
  }

  return (
    <div className={classes.container}>
      <span className={classes.title} style={{ color: primaryColor }}>
        Chave PIX
      </span>
      <div className={classes.keyPIXBox}>
        <span>{maskedKeyPIX}</span>
        <Button endIcon={<FileCopy style={{ color: primaryColor }} />} onClick={handleCopyKeyPIXClick}>
          <Typography style={{ color: primaryColor, fontWeight: 'bold' }}>
            {hasCopied ? 'COPIADO' : 'COPIAR CHAVE'}
          </Typography>
        </Button>
      </div>
      {isKeyPixOfTypeQrCode && (
        <div className={classes.qrcodeBox}>
          <QRCode value={keyPIX} size={250} />
        </div>
      )}
    </div>
  );
}
